function initFAQNavigation() {
    try {
        function prepareTextForSearch(searchText) { // Returns string without any whitespace and lowercase
            return searchText.trim().toLowerCase().replace(/ /g, "").replace(/&amp;/g, "&");
        };
        const linkSelectorClass = "faq-nav--link";
        const faqSelectorClass = "faq-section";
        const globalFontWeightClass = "bold__text";
        let elementToBeBold = undefined;
    
        function removeBoldFromAllLinks() {
            document.querySelectorAll( `.${linkSelectorClass}` ).forEach(function(element) { element.classList.remove(globalFontWeightClass) });
        };
    
        document.querySelectorAll(`.${linkSelectorClass}`).forEach(function(linkElem) {
            if(!!linkElem) {
                linkElem.addEventListener("click", function(e) {
                    const findQuery = prepareTextForSearch(linkElem.innerHTML);
                    document.querySelectorAll(`.${faqSelectorClass}`).forEach(function( faqElements ) {
                        const faqFindQuery = prepareTextForSearch(faqElements.dataset.faqHeader); 
                        if(findQuery == faqFindQuery) {
                            faqElements.scrollIntoView({
                                block: "center",
                                inline: "start"
                            });
                            elementToBeBold = linkElem;
                        };
                    });
                    removeBoldFromAllLinks();
    
                    if(!!elementToBeBold) {
                        elementToBeBold.classList.add( globalFontWeightClass );
                    };
    
                });
            };
        });
    } catch (e) {
    }
};

function initBgColorTransitionFunctionality() {
    try {
        const faqQuestionSelector = "faq-list__item";
        function returnBgColorToDefault() {
            document.querySelectorAll(`.${faqQuestionSelector}`).forEach(function(element) { 
                element.style.backgroundColor = "unset";
            });
        };
        document.querySelectorAll(`.${faqQuestionSelector}`).forEach(function(element) {
            element.addEventListener("click", function(e) {
                returnBgColorToDefault();
                if(!!element && element.classList.contains("is-expanded")) {
                    const bgColor = element.dataset.bgColor;
                    element.style.backgroundColor = bgColor;
                };
            });
        });
    } catch (e) {

    };
}

initFAQNavigation();
initBgColorTransitionFunctionality();


